import angular from 'angular';

import errors from './config/errorcodes.conf';
import retailerDashboardsRouting from './retailer-dashboards-routing-module';
import retailerDashboardsSearchPage from './containers/search-page/retailer-dashboards-search-page-module';
import retailerDashboardPage from './containers/dashboard-page/retailer-dashboard-page-module';

export default angular
  .module('retailer-dashboards', [
    errors.name,
    retailerDashboardsRouting.name,
    retailerDashboardsSearchPage.name,
    retailerDashboardPage.name,
  ])
;



// WEBPACK FOOTER //
// ./src/modules/retailer-dashboards/retailer-dashboards-module.js